// extracted by mini-css-extract-plugin
export default {"navWrap":"nav_navWrap__RVudS","nav":"nav_nav__7YcRR","active":"nav_active__HToSH","nextMark":"nav_nextMark__BAfRF"};